import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetVoiceActorsLookups = () => {
  return useContentSelector(({ voiceActors }) => voiceActors.lookups);
};

export const useGetVoiceActorById = () => {
  return useContentSelector(({ voiceActors }) => voiceActors.getVoiceActorById);
};

export const useCreateVoiceActor = () => {
  return useContentSelector(({ voiceActors }) => voiceActors.createVoiceActor);
};

export const useEditVoiceActor = () => {
  return useContentSelector(({ voiceActors }) => voiceActors.editVoiceActor);
};

export const useGetVoiceActorByIdMultilingual = () => {
  return useContentSelector(({ voiceActors }) => voiceActors.byIdMultilingual);
};

export const useSetContentEntityVoiceActor = () => {
  return useContentSelector(
    ({ voiceActors }) => voiceActors.setContentEntityVoiceActor
  );
};
